import { Grid } from "@mui/material";
import MDBox from "components/MDBox";

import { FormTitle, Text, DatePickerField } from "ui-components/Form";

function KitSKUInfo({ formRender, control, errors, mode="ADD" }) {
  function renderFn(property, index, length) {
    const { xs, disabled, editable, ...data } = property;
    //custom xs
    const xs2 = xs ? xs : 12 / length;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(mode === "EDIT" && editable === false && {disabled: true,type:"text"})
    };

    let renderField;
    if (data.type === "text" || data.type === "number") {
      renderField = <Text field={fieldProps} />;
    } else if (data.type === "date") {
      renderField = <DatePickerField field={fieldProps} />;
    }
    return (
      <Grid key={index} item xs={xs2}>
        {renderField}
      </Grid>
    );
  }

  return (
    <MDBox>
      <FormTitle title={mode==="EDIT"?"Edit SKU Kit":"Add SKU Kit"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((row, index) => renderFn(row, index, rows.length))}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default KitSKUInfo;
